import BaseLeadChartPage from '../BaseLeadChartPage/BaseLeadChartPage'

export default function LeadByLeadStatusReasonChartPage (props) {
  return <BaseLeadChartPage pageName={props.pageName} groupByKey={"none"} labelByKey={"lead_status_reason"}/>
}
